import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        tasklistTemplate: '='
    },
    template: `
        <ul class="items06 type03">
            <li ng-repeat="(key, condition) in vm.form.model.templateConditions">
                <div class="form">
                    <form-row error="vm.form.errors.templateConditions[key].type">
                        <label class="label">{{ 'tasklist.Condition' | translate }}</label>
                        <div class="items">
                            <select class="form-control"
                                ng-change="vm.setDefaultCreationTime(condition)"
                                ng-model="vm.form.model.templateConditions[key].type">
                                    <option value="{{ vm.TASKLIST_CONDITION_ENUM.KEYS.EMPLOYEE_JOINING }}">{{ vm.TASKLIST_CONDITION_ENUM.LABELS.EMPLOYEE_JOINING }}</option>
                                    <option value="{{ vm.TASKLIST_CONDITION_ENUM.KEYS.INACTIVITY_PERIOD_ASSIGNED }}">{{ vm.TASKLIST_CONDITION_ENUM.LABELS.INACTIVITY_PERIOD_ASSIGNED }}</option>
                                    <option value="{{ vm.TASKLIST_CONDITION_ENUM.KEYS.COURSE_PASSING }}">{{ vm.TASKLIST_CONDITION_ENUM.LABELS.COURSE_PASSING }}</option>
                            </select>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row ng-if="condition.type===vm.TASKLIST_CONDITION_ENUM.KEYS.COURSE_PASSING" error="vm.form.errors.templateConditions[key].courseId">
                        <label class="label">{{ 'tasklist.Course' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'name'"
                                selected-item="vm.selectedItems[key]"
                                ng-model="vm.form.model.templateConditions[key].courseId"
                                value-attribute="'id'"
                                query="vm.getCoursesByName(input)"
                            />
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row ng-if="condition.type"
                        error="vm.form.errors.templateConditions[key].creationPeriod
                            || vm.form.errors.templateConditions[key].creationPeriodType
                            || vm.form.errors.templateConditions[key].creationTrigger">
                        <label class="label">
                            {{ 'tasklist.Tasklist creation time' | translate }}
                        </label>
                        <div class="items">
                            <input ng-if="vm.creationColumns[condition.creationTrigger].creationPeriod" class="form-control small02" ng-model="vm.form.model.templateConditions[key].creationPeriod">
                            <select ng-if="vm.creationColumns[condition.creationTrigger].creationPeriodType" class="form-control small02"
                                ng-model="vm.form.model.templateConditions[key].creationPeriodType"
                                >
                                <option value="{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.DAY }}">{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.DAY }}</option>
                                <option value="{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.WEEK }}">{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.WEEK }}</option>
                                <option value="{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.MONTH }}">{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.MONTH }}</option>
                            </select>
                            <select class="form-control small"
                                    ng-model="vm.form.model.templateConditions[key].creationTrigger"
                                    ng-options="trigger.key as trigger.label for trigger in vm.creationTriggers[condition.type]">
                            </select>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <span
                        class="desc warn"
                        ng-if="vm.form.model.templateConditions[key].creationTrigger === vm.TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.BEFORE_WORKING_SINCE
                            || vm.form.model.templateConditions[key].creationTrigger === vm.TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.BEFORE_INACTIVITY_STARTS
                        ">
                        {{ 'tasklist.Rule Before joining' | translate }}
                    </span>
                </div>
                <a ng-if="key>0" class="btn delete" ng-click="vm.remove(key)">{{ 'general.Remove' | translate }}</a>
            </li>
        </ul>
        <a class="btn add" ng-click="vm.add()">{{ 'tasklist.Add condition' | translate }}</a>
        `
})

export default class {
    constructor ($scope, TASKLIST_CONDITION_ENUM, OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM,
        TASKLIST_CONDITION_TRIGGER_ENUM, CourseResource, lodash) {
        this.$scope = $scope;
        this.TASKLIST_CONDITION_ENUM = TASKLIST_CONDITION_ENUM;
        this.TASKLIST_CONDITION_TRIGGER_ENUM = TASKLIST_CONDITION_TRIGGER_ENUM;
        this.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM = OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM;
        this.CourseResource = CourseResource;
        this.lodash = lodash;
        this.selectedItems = [];

        this.creationTriggers = [];
        this.creationTriggers[TASKLIST_CONDITION_ENUM.KEYS.EMPLOYEE_JOINING] = [
            { key: TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.BEFORE_WORKING_SINCE, label: TASKLIST_CONDITION_TRIGGER_ENUM.LABELS.BEFORE_WORKING_SINCE },
            { key: TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.AFTER_WORKING_SINCE, label: TASKLIST_CONDITION_TRIGGER_ENUM.LABELS.AFTER_WORKING_SINCE },
            { key: TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.ON_WORKING_SINCE, label: TASKLIST_CONDITION_TRIGGER_ENUM.LABELS.ON_WORKING_SINCE }
        ];
        this.creationTriggers[TASKLIST_CONDITION_ENUM.KEYS.INACTIVITY_PERIOD_ASSIGNED] = [
            { key: TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.BEFORE_INACTIVITY_STARTS, label: TASKLIST_CONDITION_TRIGGER_ENUM.LABELS.BEFORE_INACTIVITY_STARTS },
            { key: TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.AFTER_INACTIVITY_STARTS, label: TASKLIST_CONDITION_TRIGGER_ENUM.LABELS.AFTER_INACTIVITY_STARTS },
            { key: TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.ON_INACTIVITY_START, label: TASKLIST_CONDITION_TRIGGER_ENUM.LABELS.ON_INACTIVITY_START }
        ];
        this.creationTriggers[TASKLIST_CONDITION_ENUM.KEYS.COURSE_PASSING] = [
            { key: TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.AFTER_COURSE_IS_PASSED, label: TASKLIST_CONDITION_TRIGGER_ENUM.LABELS.AFTER_COURSE_IS_PASSED },
            { key: TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.WHEN_COURSE_IS_PASSED, label: TASKLIST_CONDITION_TRIGGER_ENUM.LABELS.WHEN_COURSE_IS_PASSED }
        ];

        this.creationColumns = [];
        this.creationColumns[TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.BEFORE_WORKING_SINCE] = { creationPeriod: true, creationPeriodType: true };
        this.creationColumns[TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.AFTER_WORKING_SINCE] = { creationPeriod: true, creationPeriodType: true };
        this.creationColumns[TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.ON_WORKING_SINCE] = { creationPeriod: false, creationPeriodType: false };
        this.creationColumns[TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.BEFORE_INACTIVITY_STARTS] = { creationPeriod: true, creationPeriodType: true };
        this.creationColumns[TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.AFTER_INACTIVITY_STARTS] = { creationPeriod: true, creationPeriodType: true };
        this.creationColumns[TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.ON_INACTIVITY_START] = { creationPeriod: false, creationPeriodType: false };
        this.creationColumns[TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.AFTER_COURSE_IS_PASSED] = { creationPeriod: true, creationPeriodType: true };
        this.creationColumns[TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.WHEN_COURSE_IS_PASSED] = { creationPeriod: false, creationPeriodType: false };
    }

    $onInit () {
        if (!this.form.model.templateConditions) {
            this.form.model.templateConditions = [];
        }

        if (!this.form.model.templateConditions.length) {
            const condition = { type: this.TASKLIST_CONDITION_ENUM.KEYS.EMPLOYEE_JOINING };
            this.form.model.templateConditions.push(condition);
            this.setDefaultCreationTime(condition);
        }

        this.lodash.forEach(this.form.model.templateConditions, (templateCondition, index) => {
            if (this.form.model.templateConditions[index].courseId) {
                this.getCoursesById(this.form.model.templateConditions[index].courseId).then((response) => {
                    this.selectedItems[index] = response.activeI18n.name;
                });
            }
        });
    }

    setDefaultCreationTime (condition) {
        if (condition.type === this.TASKLIST_CONDITION_ENUM.KEYS.EMPLOYEE_JOINING) {
            condition.creationPeriod = '1';
            condition.creationPeriodType = this.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.DAY;
            condition.creationTrigger = this.TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.BEFORE_WORKING_SINCE;
        }
        if (condition.type === this.TASKLIST_CONDITION_ENUM.KEYS.INACTIVITY_PERIOD_ASSIGNED) {
            condition.creationPeriod = '1';
            condition.creationPeriodType = this.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.DAY;
            condition.creationTrigger = this.TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.BEFORE_INACTIVITY_STARTS;
        }
        if (condition.type === this.TASKLIST_CONDITION_ENUM.KEYS.COURSE_PASSING) {
            condition.creationPeriod = '1';
            condition.creationPeriodType = this.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.DAY;
            condition.creationTrigger = this.TASKLIST_CONDITION_TRIGGER_ENUM.KEYS.WHEN_COURSE_IS_PASSED;
        }
    }

    getCoursesByName (name) {
        const params = {
            name,
            pageSize: 0,
            expand: 'activeI18n'
        };
        return this.CourseResource.query(params).$promise.then((response) => {
            return response.map((course) => ({ id: course.id, name: course.activeI18n.name }));
        });
    }

    getCoursesById (id) {
        const params = {
            id,
            pageSize: 0,
            expand: 'activeI18n'
        };
        return this.CourseResource.getCourse(params).$promise;
    }

    remove (key) {
        if (this.form.model.templateConditions.length > 1) {
            this.form.errors.templateConditions = false;
            this.form.model.templateConditions.splice(key, 1);
        }
    }

    add () {
        this.form.model.templateConditions.push({ type: null });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/tasklist/templates/form/condition/index.js